<app-navbar title="Płatności"></app-navbar>

<section class="m-3">
	<div class="mb-2">
		<mat-accordion multi>
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<mat-panel-title
						><i class="fa fa-filter"></i><span class="ms-2 font-wegiht-700">Filtry</span></mat-panel-title
					>
				</mat-expansion-panel-header>
				<app-bag-payment-list-table-filters
					userFilters="paymentList"
					[forceFilters]="{ limit: 9999 }"
					[organizations]="parameters.organizations"
					[agencies]="parameters.agencies"
					[status]="parameters.status"
					[paymentKinds]="parameters.paymentKinds"
					[reservationStatus]="parameters.reservationStatus"
					[currency]="parameters.currency"
					[bankAccounts]="parameters.bankAccounts"
					(selected)="filtersSelected($event)"
				></app-bag-payment-list-table-filters>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
	<app-bag-payment-list-add
		[bankAccounts]="parameters.bankAccounts"
		[profileData]="parameters.profileData"
	></app-bag-payment-list-add>
	<div class="pb-6">
		<app-bag-payment-list-table
			module="paymentList"
			[tableColumns]="paymentColumns"
			[elements]="data"
		></app-bag-payment-list-table>
		<div class="col-sm-2" *ngIf="data['summary']?.length > 0">
			<app-bag-payment-list-table-summary
				[data]="data['summary']"
				[tableColumns]="summaryColumns"
			></app-bag-payment-list-table-summary>
		</div>
	</div>
</section>
